import { render, staticRenderFns } from "./ContentCheckbox.vue?vue&type=template&id=1030283a&scoped=true&"
import script from "./ContentCheckbox.vue?vue&type=script&lang=js&"
export * from "./ContentCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ContentCheckbox.vue?vue&type=style&index=0&id=1030283a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1030283a",
  null
  
)

export default component.exports